import React, { useEffect, useRef, useState } from 'react';
import { Button, Container, Form, Input, Label, FormGroup, FormText } from 'reactstrap';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';

import { forgotPasswordActions } from '../../../../core/forgotPassword/actions';
import { useLocation, useNavigate } from 'react-router-dom';
import { passwordStrengthChecker } from '../../../../core/helper';
import LoadingIndicator from '../../../components/loading-indicator';

const animationClass = {
    appearActive: 'animate__animated animate__slideInRight',
    enter: 'animate__animated',
    enterActive: 'animate__animated animate__slideInRight',
    exit: 'animate__animated',
    exitActive: 'animate__animated animate__slideOutLeft',
}

export const ResetPassword = ({ forgotPassword, changePassword }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const tokenIdFromUrl = searchParams.get('token_id');
    const codeFromUrl = searchParams.get('code');
    const [disable, setDisabled] = useState(true);
    const nodeRef = useRef(null);
    const [inputValues, setInputValues] = useState({
        password: '',
        confirm_password: '',
    })
    const [formErrors, setformErrors] = useState({
        password: '',
        confirm_password: '',
    });
    const strength = passwordStrengthChecker(inputValues.password)

    useEffect(() => {
        setDisabled(!formValid());
        !forgotPassword.isPending && forgotPassword.success && forgotPassword.action === forgotPasswordActions.CHANGE_PASSWORD && navigate('/reset-password-done');
    }, [inputValues, forgotPassword])

    useEffect(() => {
        const hasReduxContext = Boolean(
            forgotPassword.validation_code && forgotPassword.data?.id
        );
        const hasUrlContext = Boolean(tokenIdFromUrl && codeFromUrl);

        if (!hasReduxContext && !hasUrlContext) {
            navigate('/forgot-password', { replace: true });
        }
    }, [forgotPassword.validation_code, forgotPassword.data, tokenIdFromUrl, codeFromUrl, navigate])


    const handleInputChange = async ({ target }) => {
        const { name, value } = target;

        switch (name) {
            case "password":
                formErrors.password = value.length < 8 ? "Minimum 8 characters required" : '';

                if(inputValues.confirm_password)
                {
                    let matchPassword = inputValues.confirm_password === value ? '' : 'Password did not matched';
                    formErrors.confirm_password = inputValues.confirm_password?.length < 8 ? "Minimum 8 characters required" : matchPassword;
                }
                break;
            case "confirm_password":
                let matchPasswordConfirm = inputValues.password === value ? '' : 'Password did not matched';
                formErrors.confirm_password = value.length < 8 ? "Minimum 8 characters required" : matchPasswordConfirm;
                break;
            default:
                break;
        }

        setInputValues({
            ...inputValues,
            [name]: value
        });
    }

    const formValid = () => {
        let valid = true;

        // validate form errors being empty
        Object.values(formErrors).forEach(val => {
            val.length > 0 && (valid = false);
        });

        // validate the form was filled out
        Object.values(inputValues).forEach(val => {
            val === '' && (valid = false);
        });

        if (strength === 'Too weak!') valid = false

        return valid;
    };

    const onSubmitChagePWD = (e) => {
        e.preventDefault();
        changePassword({
            ...inputValues,
            ...(tokenIdFromUrl
                ? { token_id: tokenIdFromUrl }
                : { id: forgotPassword.data?.id }),
            code: forgotPassword.validation_code || codeFromUrl
        })
    }

    return (
        <>
            {forgotPassword.isPending && <LoadingIndicator />}

            <Container fluid="xl" className='minvh-100 overflow-hidden position-relative px-0 px-md-3'>
                <TransitionGroup component={null} >
                    <CSSTransition nodeRef={nodeRef} classNames={animationClass} timeout={{ enter: 1000, exit: 1000 }} key='confirm' appear >
                        <div ref={nodeRef} className='d-flex flex-column align-items-center minvh-100'>
                            <div className="forgot-password-page bg-white p-4 my-auto">
                                <div className='mb-3 pt-md-3 d-flex align-items-center'>
                                    <Button color='link' className="text-body p-0 mr-3 mb-1" onClick={() => navigate('/forgot-password')}>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="24" height="20" viewBox="0 0 24 20">
                                            <path d="M24,10c0,0.3-0.1,0.5-0.3,0.7C23.5,10.9,23.3,11,23,11H3.4l7.3,7.3c0.1,0.1,0.2,0.2,0.2,0.3
                                                C11,18.7,11,18.9,11,19c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2C10.3,20,10.1,20,10,20
                                                c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2l-9-9c-0.1-0.1-0.2-0.2-0.2-0.3C0,10.3,0,10.1,0,10c0-0.1,0-0.3,0.1-0.4
                                                c0.1-0.1,0.1-0.2,0.2-0.3l9-9C9.5,0.1,9.7,0,10,0c0.3,0,0.5,0.1,0.7,0.3C10.9,0.5,11,0.7,11,1c0,0.3-0.1,0.5-0.3,0.7L3.4,9H23
                                                c0.3,0,0.5,0.1,0.7,0.3C23.9,9.5,24,9.7,24,10z"/>
                                        </svg>
                                    </Button>
                                    <h1 className='libre-caslon-text-regular h3-md h4 mb-0'>Create New Password</h1>
                                </div>
                                <p className='mb-3'>Passwords should be minimum 8 characters long and include a combination of numbers and upper and lowercase letters</p>
                                <Form onSubmit={onSubmitChagePWD} className="form-login">
                                    <FormGroup>
                                        <Label for="password" className={formErrors.password !== '' ? 'text-danger' : ''}>Enter your new password</Label>
                                        <Input
                                            type="password"
                                            name="password"
                                            id="password"
                                            placeholder="Enter your New Passowrd"
                                            onChange={handleInputChange}
                                            value={inputValues.password}
                                            invalid={formErrors.password === '' ? null : true}
                                        />
                                        {formErrors.password && <FormText color='danger'>{formErrors.password}</FormText>}
                                        {(inputValues.password && !formErrors.password) && <FormText>{strength}</FormText>}
                                    </FormGroup>
                                    <FormGroup>
                                        <Label for="pwd" className={
                                            formErrors.confirm_password
                                                ? 'text-danger'
                                                : (!formErrors.password && inputValues.confirm_password) ? 'text-green' : ''
                                        }>
                                            Confirm New Password
                                        </Label>
                                        <Input
                                            type="password"
                                            name="confirm_password"
                                            id="pwd"
                                            placeholder="Re-enter your New Password"
                                            className={(inputValues.confirm_password && !formErrors.confirm_password && !formErrors.password) ? 'text-green' : ''}
                                            onChange={handleInputChange}
                                            value={inputValues.confirm_password}
                                            invalid={formErrors.confirm_password === '' ? null : true}
                                        />
                                        {formErrors.confirm_password && <FormText color='danger'>{formErrors.confirm_password}</FormText>}
                                    </FormGroup>
                                    <Button type="submit" color="green-light" className='py-2 rounded-sm' size='sm' block disabled={disable}>
                                        Create New Password
                                    </Button>
                                </Form>
                            </div>
                        </div>
                    </CSSTransition>
                </TransitionGroup>
            </Container>
        </>
    )
}

const mapStateToProps = (state, props) => {
    const { forgotPassword } = state;
    return {
        forgotPassword
    };
};

const mapDispatchToProps = {
    changePassword: forgotPasswordActions.changePassword
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResetPassword);
